import { useEffect } from "react";

/**
 * Mounts the Elido Nexus Core widget (vanilla JS, Shadow DOM) on whatever
 * page renders this component. Idempotent: if the widget is already loaded
 * (singleton flag set by widget.js itself or another <SiteWidget /> mount),
 * we skip injection — so it's safe to drop into multiple pages without
 * duplicate launchers.
 *
 * The script tag is appended via DOM (not Helmet) so the IIFE runs reliably
 * on first paint and `document.currentScript` resolves correctly.
 */
export default function SiteWidget({ clientId = "elido-ab" }) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.__elidoWidgetLoaded) return;
    if (document.querySelector('script[data-elido-widget="1"]')) return;

    const s = document.createElement("script");
    s.src = "/widget.js";
    s.defer = true;
    s.setAttribute("data-client-id", clientId);
    s.setAttribute("data-elido-widget", "1");
    document.body.appendChild(s);
    // Intentionally no cleanup: the widget mounts a Shadow DOM root on
    // document.body that is meant to live for the full page lifetime
    // (and across in-app SPA navigations).
  }, [clientId]);

  return null;
}
